/** Display customer ref with # prefix (admin list, search). */
export function formatCustomerReference(reference: string | null | undefined): string | null {
  const raw = reference?.trim();
  if (!raw) return null;
  return raw.startsWith('#') ? raw : `#${raw}`;
}

export function customerReferenceSearchKey(reference: string | null | undefined): string {
  const raw = reference?.trim();
  if (!raw) return '';
  return raw.replace(/^#/, '').toLowerCase();
}
